import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logo-2026-08.webp")